/**
	Static object used between components for non-critical, non-state
 */

export default {};
